import React, { useEffect, useState } from 'react'
import { DirectionalProps } from './Directional.d'
import { Controls } from '@toasttab/shared/src/utils/craftUtils'

import classNames from 'classnames'

const Previous = ({
  variation = 'primary',
  size = '48',
  disabled = false,
  classes
}: DirectionalProps) => {
  const colors = Controls.getDirectionalVariationColors(variation)
  const [circleColor, setCircleColor] = useState<string>(colors.circleColor)
  const [pathColor, setPathColor] = useState<string>(colors.pathColor)
  const [circleBackgroundColor, setCircleBackgroundColor] = useState<string>(
    colors.backgroundColor
  )

  useEffect(() => {
    if (disabled) {
      setPathColor(colors.disabled.pathColor)
      setCircleColor(colors.disabled.circleColor)
      setCircleBackgroundColor(colors.disabled.backgroundColor)
    } else {
      setPathColor(colors.pathColor)
      setCircleColor(colors.circleColor)
      setCircleBackgroundColor(colors.backgroundColor)
    }
  })

  const svgClasses = classNames(classes, 'rounded-round', {
    'shadow-xl': variation === 'elevated'
  })

  const hoverMouseIn = () => {
    setPathColor(colors.pathColorHover)
    setCircleColor(colors.circleColorHover)
    setCircleBackgroundColor(colors.backgroundColorHover)
  }

  const hoverMouseOut = () => {
    setPathColor(colors.pathColor)
    setCircleColor(colors.circleColor)
    setCircleBackgroundColor(colors.backgroundColor)
  }

  return (
    <svg
      className={`${svgClasses} !w-12 !h-12`}
      data-testid='control-previous'
      overflow='visible'
      tabIndex={disabled ? -1 : 0}
      viewBox='0 0 42 42'
      xmlns='http://www.w3.org/2000/svg'
      onMouseEnter={() => {
        if (!disabled) hoverMouseIn()
      }}
      onMouseLeave={() => {
        if (!disabled) hoverMouseOut()
      }}
    >
      <circle
        cx='21'
        cy='21'
        data-testid='control-previous-circle'
        fill={circleBackgroundColor}
        r='20'
        stroke={circleColor}
        strokeWidth={2}
      />
      <path
        d='M23.7 16L18 21l5.7 5'
        data-testid='control-previous-path'
        fill='transparent'
        stroke={pathColor}
        strokeWidth={2}
      />
    </svg>
  )
}

export default Previous
